import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgentsService } from '../utils/services/agents.service';
import { Agent } from '../utils/models/agent.model';
import { DialogService } from '../dialogservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SharedService } from '../utils/services/shared.service';
import { MessageService } from '../utils/services/message.service';
import { Message } from '../utils/models/message.model';
import { catchError } from 'rxjs/operators';
import { UserService } from '../utils/services/user.service';
import { KeycloakService } from 'keycloak-angular';
import { Socket } from 'ngx-socket-io';
import { BookableTimeSlotsService } from '../utils/services/bookable-time-slots.service';
import moment from 'moment';
import { EmitType } from '@syncfusion/ej2-base';
import { Query } from '@syncfusion/ej2-data';
import { FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { WhatsAppMessagesService } from '../utils/services/whats-app-messages.service';
import { WhatsAppMessage } from '../utils/models/whats-app-message.model';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AgentStatusTransitionService } from '../utils/services/agent-status-transition.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { FormsModule } from '@angular/forms';
import { CheckBoxModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { EditorModule } from '@tinymce/tinymce-angular';
import { SpinnerComponent } from '../spinner/spinner.component';
import { MoveAgentComponent } from '../move-agent/move-agent.component';
import { AgentWithdrawApplicationComponent } from '../dialogs/agent-withdraw-application/agent-withdraw-application.component';
import { RecordComponent } from '../record/record.component';
import { VoicePlayerComponent } from '../voice-player/voice-player.component';
import JSZip from 'jszip';
import { RecordingService } from '../utils/services/recording.service';
import { DateFormatDirective } from '../utils/date-format.directive';
import { CustomMomentDateAdapter, GermanDateFormats } from '../shared/custom.moment.date.adapter';
import { TimerService } from '../utils/services/timer.service';
import { Subject, debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { PartnersService } from '../utils/services/partners.service';

@Component({
  selector: 'app-agentview',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    CheckBoxModule,
    SwitchModule,
    DropDownListModule,
    EditorModule,
    MoveAgentComponent,
    AgentWithdrawApplicationComponent,
    RecordComponent,
    VoicePlayerComponent,
    SpinnerComponent,
    DateFormatDirective,
    DateTimePickerModule
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomMomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: GermanDateFormats },
  ],
  templateUrl: './agentview.component.html',
  styleUrl: './agentview.component.scss'
})
export class AgentviewComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private agentsService: AgentsService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public dialogService: DialogService,
    public snackBar: MatSnackBar,
    private router: Router,
    public sharedService: SharedService,
    private messageService: MessageService,
    private userService: UserService,
    protected readonly keycloak: KeycloakService,
    private socket: Socket,
    private btsService: BookableTimeSlotsService,
    private dateAdapter: DateAdapter<any>,
    private sanitizer: DomSanitizer,
    private readonly whatsAppMessagesService: WhatsAppMessagesService,
    private recordingService: RecordingService,
    private timerService: TimerService,
    private keycloakService: KeycloakService,
    private agentStatusTransitionService: AgentStatusTransitionService,
    public partnersService: PartnersService
  ) {
    this.messageSubscription = this.socket.fromEvent('newMessage').subscribe((message: any) => {
      if (
        this.currentRole === message.receiverRole ||
        this.currentRole === message.sendersRole
      ) {
        this.messages.push(message);
        setTimeout(() => {
          this.scrollToBottom();
        }, 50);
        if (!this.isAgentUser && this.currentRole === message.receiverRole) {
          setTimeout(() => {
            this.messageService.markMessagesAsRead(message).subscribe();
          }, 50);
        }
      }
    });
    if (!this.isAgentUser) {
      this.whatsAppMessageSubscription = this.whatsAppMessagesService.onNewWhatsAppMessage().subscribe((whatsAppMessage: WhatsAppMessage) => {
        if (whatsAppMessage.senderName !== 'Admin' && this.remainingTime === '00:00:00') {
          this.whatsAppMessagesService
        .getFirstMessageReceivedTime(whatsAppMessage.projectId, whatsAppMessage.agentId)
        .subscribe((time: any) => {
          this.remainingTime = time.receivedAt ?? '00:00:00';
          this.timerService.startTimer(new Date(time.receivedAt));
        });
      }
        if (this.currentRole === 'Admin') {
          this.whatsAppMessages.push(whatsAppMessage);
          setTimeout(() => {
            this.scrollToBottom();
          }, 50);
          setTimeout(() => {
            this.whatsAppMessagesService.markWhatsAppMessagesAsRead(whatsAppMessage).subscribe();
          }, 50);
        }
      });
    }

    this.detectDevice();

    this.dateAdapter.setLocale('de-DE');

    this.timerSubscription = this.timerService.expirationTime$.subscribe((time : any)=> {
        this.remainingTime = time;
      
    });
  }

  private messageSubscription: Subscription;
  private whatsAppMessageSubscription: Subscription | undefined;

  public id: number = -1;
  public publicId: string | null = '';
  public agent: Agent | any = null;
  public isAccessedPublicly: boolean = false;
  public currentRole: string = 'Client';
  public isAdminLoggedIn: boolean = false;

  public internalNotePartner: string = '';
  public internalNoteClient: string = '';
  public internalNoteAdmin: string = '';
  public selectedAgentVoiceFiles: [] = [];
  public currentPath = '';
  public isAgentUser: boolean = false;
  public agentId: string = '';
  public projectId: number = -1;
  public messageToSent: string = '';
  public messages: Message[] = [];
  public whatsAppMessages: WhatsAppMessage[] = [];
  public currentUser: string = '';
  public currentUserName: string = '';
  public currentRoles: any;
  public isSingleProjectView = true;
  isEditable: boolean = false;
  chatChannel: string = '';
  whatsAppChatChannel: string = '';
  defaultProfileImageSrc =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQvUjKpRjWsF2voE76xA88VIoqx_WemiQxhsQ&usqp=CAU';
  profileImageSrc:any = null;
  profilePhoto: any;
  isSpinnerActive: boolean = false;
  componentInitialized: boolean = false;

  public isDirty: boolean = false;

  deleteDialogConfirmationPopup: boolean = false;
  isAgentReplied: boolean = false;
  agentForDelete: any = {};
  currentSW: any = {};
  private timerSubscription!: Subscription;
  private destroy$ = new Subject<void>();

  phoneChange$ = new Subject<string>();
  emailChange$ = new Subject<string>();

  phoneExists = false;
  emailExists = false;

  @ViewChild('chatBot') chatBot!: ElementRef;

  @Input()
  public data: any = {};

  @Input()
  public projectViewsCurrentRole: string = '';

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  kanbanStatus: any = [];
  agentStatus = '';
  @Output() onstatusChange: EventEmitter<any> = new EventEmitter();
  @Output() onMoveAgent: EventEmitter<any> = new EventEmitter();
  @Output() closeView: EventEmitter<any> = new EventEmitter();
  @Output() assessmentDateChanged: EventEmitter<any> = new EventEmitter();

  public agentMoveDate = {};
  public timeSlotList: any = [];
  agentAppointment: any = {};
  initialAppointment: string = '';
  appointmentDateTime: Date | null = null;
  agentAssessment: any = {};
  initialAssessment: string = '';
  assessmentDateTime: Date | null = null;
  minDate: Date = new Date(new Date().setHours(0, 0, 0, 0));
  // Lokale Speicherung der vom Benutzer ausgewählten Termine
  userSelectedAssessmentTime: string | null = null;
  userSelectedInterviewTime: string | null = null;
  agentProjectHistory: any;

  @Input()
  public statuses: any[] = [];

  countryCode = [
    "+49",
    "+90",
    "+1",
    "+1-242",
    "+1-246",
    "+1-264",
    "+1-268",
    "+1-284",
    "+1-340",
    "+1-345",
    "+1-441",
    "+1-473",
    "+1-649",
    "+1-664",
    "+1-670",
    "+1-671",
    "+1-684",
    "+1-721",
    "+1-758",
    "+1-767",
    "+1-784",
    "+1-787",
    "+1-809",
    "+1-829",
    "+1-849",
    "+1-868",
    "+1-869",
    "+1-876",
    "+1-939",
    "+20",
    "+211",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+27",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+36",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+383",
    "+385",
    "+386",
    "+387",
    "+389",
    "+39",
    "+40",
    "+41",
    "+420",
    "+421",
    "+423",
    "+43",
    "+44",
    "+44-1481",
    "+44-1534",
    "+44-1624",
    "+45",
    "+46",
    "+47",
    "+48",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+590",
    "+591",
    "+592",
    "+593",
    "+595",
    "+597",
    "+598",
    "+599",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+7",
    "+81",
    "+82",
    "+84",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+86",
    "+880",
    "+886",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+98",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
  ];
  public fields: { text: string; value: string } = { text: '', value: '' };
  public field: { text: string; value: string } = { text: 'text', value: 'value' };

  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement!: ElementRef<HTMLCanvasElement>;
  deviceType = '';
  userAgent = '';
  videoStream: MediaStream | null = null;
  hasWebcam: boolean = false;
  isWebcamOn: boolean = false;
  isFromOpenTasks: boolean = false;
  salutation = ['Herr', 'Frau', 'Divers'];
  question = [{ text: 'Ja', value: 'true' }, { text: 'Nein', value: 'false' }];
  languageLevel = [{ text: 'Schlecht', value: 'Bad' }, { text: 'Mittel', value: 'Medium' }, { text: 'Gut', value: 'Good' }];
  outboundExperienceLevel = [{ text: 'Keine', value: 'None' }, { text: 'Mittel', value: 'Medium' }, { text: 'Gut', value: 'Good' }];
  noticePeriod = [{ value: 'no notice period', text: 'keine Kündigungsfrist' }, { value: '2 weeks', text: '2 Wochen' }, { value: '4 weeks', text: '4 Wochen' }, { value: '6 weeks', text: '6 Wochen' }]
  dropdownFields: Object = { text: 'display', value: 'name' };
  appointmentDropdownFields: Object = { text: 'display', value: 'display' };
  assessmentDropdownFields: Object = { text: 'display', value: 'display' };
  @Output() onselectInterviewDate: EventEmitter<any> = new EventEmitter();

  @Input()
  public partners: string[] = [];

  @Input()
  public partnerId: string = 'false';

  @Input()
  public partnerName: string = '';

  remainingTime: string = '00:00:00';
  latestFirstMessage: any = null;
  private intervalId: any;

  getTextForValueForOutboundExperienceLevel(value: string) {
    if (!value) {
      return '';
    }
    return this.outboundExperienceLevel.find((item) => item.value === value)?.text ?? '';
  }

  ngOnInit() {
    this.phoneChange$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(phone => this.agentsService.checkPhoneNumber(phone)),
      takeUntil(this.destroy$)
    ).subscribe((res: any) => {
      this.phoneExists = res.exists;
    });

    this.emailChange$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(email => this.agentsService.checkEmail(email)),
      takeUntil(this.destroy$)
    ).subscribe((res: any) => {
      this.emailExists = res.exists;
    });

    this.timerService.expirationTimeSubject.next('00:00:00');
    this.isSpinnerActive = true;

    // Get current path to check if we're in a public view
    this.currentPath = this.router.url;
    this.isAgentUser = this.currentPath.includes('public');
    
    // Initialize user fields with empty strings to prevent undefined errors
    this.currentUser = '';
    this.currentUserName = '';
    
    // Only check for login if NOT in a public URL
    if (!this.isAgentUser) {
      // We should be logged in for non-public views
      if (this.keycloakService.isLoggedIn()) {
        this.keycloakService.loadUserProfile().then((profile) => {
          this.currentUser = profile.email || '';
          this.currentUserName = `${profile.firstName} ${profile.lastName}` || '';       
        }).catch(error => {
          console.error('Error loading user profile:', error);
        });
      } else {
        console.warn('User is not logged in but accessing a non-public view');
      }
    } else {
      // For public views, set a generic user name if needed
      this.currentUserName = 'Agent User';
    }

    if (this.router.url == '/open-tasks') {
      this.isFromOpenTasks = true;
    }
  
    if (this.data) {
      this.agentId = this.data.agentId;
      this.projectId = this.data.projectId;
  
      if (this.data.agentId) {
        this.id = this.data.agentId;
        this.agentsService.getAgentById(this.data.agentId).subscribe((agent: any) => {
          this.agent = agent;
          this.agentProjectHistory = JSON.parse(this.agent.projectHistory);
  
          const splitPhoneNumber: string[] = this.agent.phoneNumber.split(' ');
          if (splitPhoneNumber.length > 1) {
            this.agent.countryCode = splitPhoneNumber.shift();
            this.agent.phoneNumber = splitPhoneNumber.join(' ');
          }
  
          this.agentStatus = this.agent?.status;
          this.profileImageSrc = this.agent?.agentProfilePhoto?.photoBlob
            ? this.agentsService.convertImagetoUrl(this.agent.agentProfilePhoto.photoBlob)
            : null;
  
          // Setze die DateTimePicker-Werte, wenn Termine bereits vorhanden sind
          if (this.agent?.interviewAppointment) {
            // Versuche zuerst, den vom Benutzer gespeicherten Wert aus dem localStorage zu laden
            if (this.agent.id) {
              const savedTime = localStorage.getItem(`interview_time_${this.agent.id}`);
              if (savedTime) {
                this.userSelectedInterviewTime = savedTime;
                console.log('Gespeicherter Interview-Termin geladen:', savedTime);
                
                // Setze auch den DateTimePicker auf den gespeicherten Wert
                try {
                  // Parsen des gespeicherten Datums (Format: dd.MM.yyyy HH:mm)
                  const parts = savedTime.split(' ');
                  const dateParts = parts[0].split('.');
                  const timeParts = parts[1].split(':');
                  
                  const day = parseInt(dateParts[0], 10);
                  const month = parseInt(dateParts[1], 10) - 1; // Monate sind 0-basiert in JavaScript
                  const year = parseInt(dateParts[2], 10);
                  const hour = parseInt(timeParts[0], 10);
                  const minute = parseInt(timeParts[1], 10);
                  
                  const date = new Date(year, month, day, hour, minute);
                  this.appointmentDateTime = date;
                } catch (error) {
                  console.error('Fehler beim Parsen des gespeicherten Datums:', error);
                }
              } else {
                // Wenn nichts im localStorage, verwende den Serverwert
                const { date, localFormattedDate } = this.parseISODateString(this.agent.interviewAppointment);
                this.appointmentDateTime = date;
                this.userSelectedInterviewTime = localFormattedDate;
              }
            } else {
              // Parsen des Datums aus dem ISO-String und explizite Extraktion der Komponenten
              const { date } = this.parseISODateString(this.agent.interviewAppointment);
              this.appointmentDateTime = date;
            }
          }
          if (this.agent?.assessmentAppointment) {
            this.initialAssessment = this.agent.assessmentAppointment;
            
            // Parsen des Datums aus dem ISO-String und explizite Extraktion der Komponenten
            const { date } = this.parseISODateString(this.agent.assessmentAppointment);
            this.assessmentDateTime = date;
            
            // Versuche zuerst, den vom Benutzer gespeicherten Wert aus dem localStorage zu laden
            if (this.agent.id) {
              const savedTime = localStorage.getItem(`assessment_time_${this.agent.id}`);
              if (savedTime) {
                this.userSelectedAssessmentTime = savedTime;
                console.log('Gespeicherter Assessment-Termin geladen:', savedTime);
                
                // Setze auch den DateTimePicker auf den gespeicherten Wert
                try {
                  // Parsen des gespeicherten Datums (Format: dd.MM.yyyy HH:mm)
                  const parts = savedTime.split(' ');
                  const dateParts = parts[0].split('.');
                  const timeParts = parts[1].split(':');
                  
                  const day = parseInt(dateParts[0], 10);
                  const month = parseInt(dateParts[1], 10) - 1; // Monate sind 0-basiert in JavaScript
                  const year = parseInt(dateParts[2], 10);
                  const hour = parseInt(timeParts[0], 10);
                  const minute = parseInt(timeParts[1], 10);
                  
                  const date = new Date(year, month, day, hour, minute);
                  this.assessmentDateTime = date;
                } catch (error) {
                  console.error('Fehler beim Parsen des gespeicherten Datums:', error);
                }
              } else {
                // Wenn nichts im localStorage, dann formatiere aus dem Serverwert
                const { date, localFormattedDate } = this.parseISODateString(this.agent.assessmentAppointment);
                this.assessmentDateTime = date;
                this.userSelectedAssessmentTime = localFormattedDate;
              }
            }
          }
          
          // Partner-Info nur anzeigen, wenn es keine öffentliche URL ist
          if (this.agent?.partnerId && !this.isAgentUser) {
            this.getPartnerInfo(this.agent.partnerId);
          }
          if (this.agent?.project?.client) {
            this.getClientInfo(this.agent.project.client);
          }
  
          this.sharedService.agentSubject.next(agent);
          this.publicId = this.agent?.public_id || '';
  
          this.getActualUserRole().then(() => {
            if (!this.isAgentUser && this.isAllowedToViewMessages()) {
              this.getMessages();
            }
            this.getProjectTimeSlot(this.projectId);
          });
  
          this.chatChannel = `${this.publicId}`;
          if (!this.isAgentUser) {
            this.messageService.joinChannel(this.chatChannel);
            this.whatsAppChatChannel = `${this.projectId}-${this.agent.id}`;
            this.whatsAppMessagesService.joinChannel(this.whatsAppChatChannel);
          }
  
          this.getProjectTimeSlot(this.projectId);
          this.getstatusArray();
  
          this.isAccessedPublicly = false;
          this.isSpinnerActive = false;
          if (agent.agentProfilePhoto?.id) {
            this.agentsService.getAgentProfilePhoto(agent.agentProfilePhoto.id).subscribe({
              next: (photo:any) => {
                agent.agentProfilePhoto['photoBlob'] = photo.photoBlob;
                this.profileImageSrc = this.agentsService.convertImagetoUrl(photo.photoBlob);
                // this.changeDetectorRef.detectChanges();
              },
              error: (err) => {
                console.error(`Failed to load photo for agent ${agent.id}`, err);
              }
            });
          }
        });
      }
    }
  
    this.currentPath = this.router.url;
    this.isAgentUser = this.currentPath.includes('public');
  
    this.getActualUserRole().then(() => {
      if (this.isAdminLoggedIn) {
        this.changeDetectorRef.detectChanges();
      }
    });
  
    this.route.params.subscribe((params) => {
      const id = params['id'];
      const publicId = params['publicId'];
  
      if (publicId) {
        this.isSingleProjectView = false;
        this.publicId = publicId;
        this.agentsService.getAgentByPublicId(publicId).subscribe({
          next: (agent: any) => {
            this.agent = agent;
  
            const splitPhoneNumber = this.agent.phoneNumber.split(' ');
            if (splitPhoneNumber.length > 1) {
              this.agent.countryCode = splitPhoneNumber.shift();
              this.agent.phoneNumber = splitPhoneNumber.join(' ');
            }
  
            this.agentStatus = this.agent?.status;
            this.profileImageSrc = this.agent.agentProfilePhoto
              ? this.agentsService.convertImagetoUrl(this.agent.agentProfilePhoto.photoBlob)
              : null;
  
            // Setze die DateTimePicker-Werte, wenn Termine bereits vorhanden sind
            if (this.agent?.interviewAppointment) {
              const { date } = this.parseISODateString(this.agent.interviewAppointment);
              this.appointmentDateTime = date;
            }
            if (this.agent?.assessmentAppointment) {
              const { date } = this.parseISODateString(this.agent.assessmentAppointment);
              this.assessmentDateTime = date;
            }
  
            // Partner-Info nicht für öffentliche URLs anzeigen
            // Öffentliche URLs werden durch publicId identifiziert
            // if (this.agent?.partnerId && !this.agent.isApplicationWithdraw) {
            //   this.getPartnerInfo(this.agent.partnerId);
            // }
            if (this.agent?.project?.client && !this.agent.isApplicationWithdraw) {
              this.getClientInfo(this.agent.project.client);
            }
            if (this.agent?.project) {
              this.getProjectTimeSlot(this.agent.project.id);
            }
  
            this.sharedService.agentSubject.next(agent);
            this.publicId = this.agent?.public_id || '';
  
            // Ensure role is correctly set before making a decision
            this.getActualUserRole().then(() => {
              if (!this.isAgentUser && this.isAllowedToViewMessages()) {
                this.getMessages();
              }
            });
  
            this.isAccessedPublicly = true;
            this.isSpinnerActive = false;
          },
          error: (err) => {
            this.snackBar.open(err.error.message, '', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          },
        });
      }
      setTimeout(() => {
        this.scrollToBottom();
      }, 150);
    });
  }
  
  private async getActualUserRole(): Promise<void> {
    return new Promise((resolve) => {
      // First check if we're accessing publicly - if so, don't try to get Keycloak token
      // This prevents authentication redirects on public pages
      if (this.isAccessedPublicly || this.currentPath.includes('public')) {
        this.currentRole = 'Public';
        this.isAdminLoggedIn = false;
        return resolve();
      }
      
      try {
        const tokenData = this.keycloak.getKeycloakInstance().tokenParsed;
        const userRoles = tokenData?.realm_access?.roles || [];

        if (userRoles.includes('Admin')) {
          this.currentRole = 'Admin';
          this.isAdminLoggedIn = true;
        } else if (userRoles.includes('Partner')) {
          this.currentRole = 'Partner';
        } else if (userRoles.includes('Client')) {
          this.currentRole = 'Client';
        } else {
          this.currentRole = 'Unknown'; 
        }
      } catch (error) {
        // If there's an error getting the token, assume public access
        console.log('Error getting user role, assuming public access', error);
        this.currentRole = 'Public';
        this.isAdminLoggedIn = false;
      }

      resolve();
    });
  }

  private isAllowedToViewMessages(): boolean {
    return ['Admin', 'Partner', 'Client'].includes(this.currentRole);
  }
  
  ngAfterViewInit() {
    if (!this.isAgentUser) {
      this.scrollToBottom();
    }
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.componentInitialized = true;
    }, 5000);
  }

  getMessages() {
    if (!this.isAgentUser) {
      this.messageService
        .getMessagesByAgentandProjectId(
          this.publicId,
          this.currentRole,
          this.data.coloumnName
        )
        .subscribe((messages: Message[]) => {
          // Filtere Nachrichten basierend auf der Rolle
          if (this.currentRole === 'Admin' || this.currentRole === 'Partner') {
            // Admin und Partner sehen alle Nachrichten
            this.messages = messages;
          } else if (this.currentRole === 'Client') {
            // Kunde sieht nur eigene Nachrichten, für Kunden bestimmte Nachrichten und
            // Admin/Partner-Nachrichten, die nicht intern sind
            this.messages = messages.filter((msg) =>
              msg.sendersRole === 'Client' ||
              (msg.sendersRole === 'Admin' && !msg.intern) ||
              (msg.sendersRole === 'Partner' && !msg.intern) ||
              msg.receiverRole === 'Client'
            );
          }

          this.messages.forEach((message) => {
            this.messageService.markMessagesAsRead(message).subscribe();
          });
        });

      this.whatsAppMessagesService
        .getFirstMessageReceivedTime(this.projectId, this.data.agentId)
        .subscribe((time: any) => {
          this.remainingTime = time.receivedAt ?? '00:00:00';
          this.timerService.startTimer(new Date(time.receivedAt));
        });

      this.whatsAppMessagesService
        .findAllWhatsAppMessagesByProjectAndAgent(
          this.projectId,
          this.agent.id
        )
        .subscribe((whatsAppMessages: WhatsAppMessage[]) => {
          this.whatsAppMessages = whatsAppMessages;
          const agentMessages = this.whatsAppMessages.filter(
            (msg) => msg.senderName !== 'Admin'
          );
          this.isAgentReplied = agentMessages.length > 0;
        });
    }
  }

  openChat: 'chat' | 'whatsapp' = 'chat';

  sendMessage(isLogged: boolean) {
    if (this.isMessageEmpty()) {
      return; 
    }

    if (this.openChat === 'chat') {
      let message: Message = {
        senderId: '',
        sendersRole: '',
        receiverId: '',
        receiverRole: '',
        content: '',
        agentPublicId: '',
        timestamp: '',
        isLogged: isLogged,
        senderName: '',
        intern: this.currentRole !== 'Client' // Standardmäßig auf false setzen, wenn Client eingeloggt ist
      };

      if (this.currentRole !== 'Admin' || isLogged) {
        message.senderId = this.currentUser
        message.sendersRole = this.currentRole
        message.receiverId = 'admin.user@photonic-codes.com'
        message.receiverRole = 'Admin'
      }
      else {

        if (this.data.coloumnName === 'AgentCreatedFilesMissing' || this.data.coloumnName === 'ApplicantGetsChecked' || this.data.coloumnName === 'WaitingForAgent') {
          message.senderId = this.currentUser
          message.sendersRole = this.currentRole
          message.receiverId = ''
          message.receiverRole = 'Partner'
        }
        else {

          message.senderId = this.currentUser
          message.sendersRole = this.currentRole
          message.receiverId = ''
          message.receiverRole = 'Client'
        }
      }
      message.content = this.messageToSent
      message.agentPublicId = this.publicId || ''
      message.timestamp = new Date().toISOString()
      message.senderName = this.currentUserName || ''

      if (!this.isAgentUser ) {
        this.messageService
          .sendMessage(message)
          .pipe(
            catchError((error) => {
              console.error('Error sending message:', error)
              return error
            })
          )
          .subscribe((res) => {
            setTimeout(() => {
              this.scrollToBottom()
            }, 50)
            this.messageToSent = ''
          })
      }
    } else if (this.openChat === 'whatsapp') {
      const whatsAppMessage: WhatsAppMessage = {
        id: '',
        projectId: this.projectId,
        agentId: this.agent.id,
        phoneNumber: '',
        senderName: 'Admin',
        content: this.messageToSent,
        receivedAt: new Date().toISOString(),
        readAt: '',
        isFirstMsg: false
      };
      if (!this.isAgentUser) {
        this.whatsAppMessagesService
          .create(whatsAppMessage)
          .subscribe((res) => {
            setTimeout(() => {
              this.scrollToBottom();
            }, 50);
            this.messageToSent = '';
          });
      }
    } else {
      console.error('Invalid chat type', this.openChat);
    }
  }

  formatTimestamp(timestamp: string): string {
    const date = new Date(timestamp);
    const currentDate = new Date();

    const isCurrentWeek =
      date.getFullYear() === currentDate.getFullYear() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getDate() >= currentDate.getDate() - currentDate.getDay() &&
      date.getDate() < currentDate.getDate() + (7 - currentDate.getDay());

    if (isCurrentWeek) {
      const days = [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ];
      const dayName = days[date.getDay()];
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return `${dayName} ${hours}:${minutes}`;
    } else {
      // const formattedDate = date.toISOString().split('T')[0];
      // const hours = ('0' + date.getHours()).slice(-2);
      // const minutes = ('0' + date.getMinutes()).slice(-2);
      const formattedDate = moment(date).format('DD.MM.YYYY HH:mm');
      return `${formattedDate}`;
    }
  }
  getFormattedTimestamp(): string {
    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const date = new Date();
    const dayOfWeek = days[date.getDay()];
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Month is zero-indexed, so we add 1
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z${dayOfWeek}`;
  }

  scrollToBottom(): void {
    try {
      if (!this.isAgentUser) {
        this.chatBot.nativeElement.scrollTop =
          this.chatBot.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.error('Error scrolling to bottom:', err);
    }
  }

  onInputFocus(event: any) {
    event.target.classList.add('input-focus');
  }

  onInputBlur(event: any) {
    event.target.classList.remove('input-focus');
  }

  onInputBlurForPhoneNumber(event: any) {
    event.target.classList.remove('input-focus');

    if (!this.agent.phoneNumber.startsWith('0')) {
      this.agent.phoneNumber = `0 ${this.agent.phoneNumber}`;
    }
  }

  ngOnDestroy(): void {

    this.destroy$.next()
    this.destroy$.complete()
    this.remainingTime = '00:00:00'
    this.timerSubscription.unsubscribe()

    if (this.intervalId) clearInterval(this.intervalId)
    this.data = null

    if (!this.isAgentUser ) {

      this.messageService.leaveChannel(this.chatChannel)
      this.messageSubscription.unsubscribe()

      this.whatsAppMessagesService.leaveChannel(this.whatsAppChatChannel)
      this.whatsAppMessageSubscription?.unsubscribe()

      if (this.messageSubscription) this.messageSubscription.unsubscribe()
      if (this.whatsAppMessageSubscription) this.whatsAppMessageSubscription.unsubscribe()
    }

    this.messageService.leaveChannel(this.chatChannel)
    this.whatsAppMessagesService.leaveChannel(this.whatsAppChatChannel)
  }

  updateAgent(): void {
    if (this.validateForm() === false) {
      this.snackBar.open('Bitte geben Sie alle erforderlichen und gültigen Informationen ein.', '', {
        duration: 4000,
        horizontalPosition: 'end',
        verticalPosition: 'top',
      })
      return;
    }
    this.isSpinnerActive = true;
    const agentData = { ...this.agent };
    delete agentData.videoFiles;
    delete agentData.voiceFiles;
    delete agentData.project;
    delete agentData.agentProfilePhoto;
    delete agentData.interviewAppointment;
    agentData.phoneNumber = `${agentData.countryCode} ${agentData.phoneNumber}`;
    delete agentData.countryCode;
    if (agentData.birthday instanceof Date) {
      const year = agentData.birthday.getFullYear();
      const month = String(agentData.birthday.getMonth() + 1).padStart(2, '0');
      const day = String(agentData.birthday.getDate()).padStart(2, '0');

      agentData.birthday = `${year}-${month}-${day}`;
    }
    if (agentData.availableFrom instanceof Date) {
      agentData.availableFrom = agentData.availableFrom.toISOString().split('T')[0];
    }
    agentData.partnerId = this.partnersService.partners.find((partner: any) => partner.partnerName === agentData.partnerName)?.id || '';
    this.agentsService
      .partiallyUpdateAgentById(this.agent?.id, agentData)
      .subscribe({
        next: (res) => {
          if (res.id == null) {
            this.agentsService.getAgentById(this.data.agentId).subscribe((agent: any) => {
              this.agent = agent;
              const splitPhoneNumber: string[] = this.agent.phoneNumber.split(' ');
              if (splitPhoneNumber.length > 1) {
                this.agent.countryCode = splitPhoneNumber.shift();
                this.agent.phoneNumber = splitPhoneNumber.join(' ');
              }
            });
            if (res.phoneNumber == null) {
              this.snackBar.open('Die Telefonnummer ist bereits in Gebrauch, so dass wir sie nicht aktualisieren können.', '', {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
              });
            }else if (res.emailAddress == null) {
              this.snackBar.open('Die E-Mail ist bereits in Gebrauch, so dass wir sie nicht aktualisieren können.', '', {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
              });
              
            }
            
          } else {
            this.snackBar.open('Agent Daten erfolgreich gespeichert', '', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          }
          this.isSpinnerActive = false;
          this.timerService.expirationTimeSubject.next('00:00:00');
          this.remainingTime = '00:00:00';
          if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
          }
          this.closeView.emit(this.agent);
          const status = this.statuses.find(
            (status) => status.name === this.agent?.status
          );
          if (status) {
            status.agents.forEach((agent: any) => {
              if (agent.id == this.agent.id) {
                agent.name = `${this.agent.firstname} ${this.agent.lastname}`;
                agent.city = this.agent.city;
                agent.country = this.agent.country;
                agent.interviewAppointment = this.agent.interviewAppointment;
                // agent.profileImage= agent.profileImage;
              }
            });
          }
        },
        error: (error) => {
          this.dialogService.showAgentView = false;
          this.timerService.expirationTimeSubject.next('00:00:00');
          this.remainingTime = '00:00:00';
          if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
          }
          this.closeView.emit();
          this.agent = null;
          this.messages = [];
          this.whatsAppMessages = [];
          this.sharedService.agentVoicesSubject.next([]);
          this.isSpinnerActive = false;
        }
      });
  }

  showWithdraw(): void {
    this.dialogService.showWithdrawApplicationDialog = true;
  }

  reactivatAgent() {
    // this.agentsService
    //   .updateAgentStatus(this.agent?.id, { AgentStatus: this.agent.status })
    //   .subscribe({
    //     next: (res) => {
    //       this.dialogService.showAgentView = false;
    //       this.onClose.emit(true);
    //     },
    //     error: (error) => {
    //       this.dialogService.showAgentView = false;
    //       this.onClose.emit(false);
    //     },
    //   });
    this.dialogService.showMoveAgentDialog = true;
    this.agentMoveDate = { ...this.agent, for: 'otherProject' };
  }

  getPartnerInfo(partnerId: number) {
    this.agentsService.getPartnerInfo(partnerId).subscribe((res) => {
      this.agent.project.partnerInfo = res;
    });
  }

  getClientInfo(clientId: number) {
    this.agentsService.getClientInfo(clientId).subscribe((res) => {
      this.agent.project.clientInfo = res;
    });
  }

  /**
   * Lädt die verfügbaren Statusoptionen für das Status-Dropdown basierend auf dem
   * AgentStatusTransitionService
   */
  getstatusArray() {
    this.kanbanStatus = []

    // Hole alle erlaubten Zielstatuses basierend auf dem aktuellen Status, der Rolle und dem Agenten
    const allowedStatuses = this.agentStatusTransitionService.getAllowedTargetStatuses(
      this.agent?.status,
      this.currentRole,
      this.agent
    )

    // Füge alle erlaubten Status zum Dropdown hinzu
    allowedStatuses.forEach(statusKey => {
      this.kanbanStatus.push(this.sharedService.statuses[statusKey])
    })

    // Behandlung spezieller Anzeigenamen für die Client-Rolle
    if (this.currentRole === 'Client') {
      this.kanbanStatus = this.kanbanStatus.map((status: any) => {
        return {
          ...status,
          display: status.customerDisplayName || status.display
        }
      })
    }
  }

  onChange() {
    this.isSpinnerActive = true;
    this.agentsService
      .updateAgentStatus(this.agent.id, { AgentStatus: this.agentStatus })
      .subscribe((res: any) => {
     if (res == null) {
        this.snackBar.open('Der Status konnte nicht aktualisiert werden.', '', {
          duration: 4000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
        this.isSpinnerActive = false;
        return;
      }       
        this.isSpinnerActive = false;
        // ToDo:event emit
        this.agent.previousStatus = this.agent?.status;
        this.agent.status = this.agentStatus;
        this.onstatusChange.emit(res);
        this.getstatusArray();

        if (this.componentInitialized) {
          this.snackBar.open('Der Status des Agenten wurde erfolgreich aktualisiert', '', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        }
      });
  }

  openMoveAgent(to: string) {
    this.dialogService.showMoveAgentDialog = true;
    this.agentMoveDate = { ...this.agent, for: to };
  }

  onAgentMove() {
    this.onMoveAgent.emit();
    this.onClose.emit(true);
    this.dialogService.showAgentView = false;
    this.timerService.expirationTimeSubject.next('00:00:00');
    this.remainingTime = '00:00:00';
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.closeView.emit();
    this.agent = null;
    this.messages = [];
    this.whatsAppMessages = [];
    this.sharedService.agentVoicesSubject.next([]);
  }

  getProjectTimeSlot(projectId: number) {
    this.btsService
      .getAllBookableTimeSlotsByProjectId(projectId)
      .subscribe((res: any) => {
        this.timeSlotList = this.formateTimeSlot(res);
        
        // Handhabung des Vorstellungsgespräch-Termins
        if (this.agent.interviewAppointment) {
          const date = new Date(this.agent.interviewAppointment)
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const year = date.getFullYear().toString()

          const dayOfWeekIndex = date.getDay()
          const days = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ]
          const dayOfWeek = days[dayOfWeekIndex]
          const timeSlot = res?.find((timeSlot: any) => {
            if (
              moment(this.agent.interviewAppointment).isSame(moment(timeSlot.toDate), 'day') ||
              moment(this.agent.interviewAppointment).isSame(moment(timeSlot.fromDate), 'day')
            ) {
              return true
            } else if (
              moment(timeSlot.toDate).isAfter(moment(this.agent.interviewAppointment)) &&
              moment(this.agent.interviewAppointment).isAfter(moment(timeSlot.fromDate))
            ) {
              return true
            } else {
              return false
            }
          })
          if (!!timeSlot) {
            const hours = date.getHours()
            const minutes = date.getMinutes()
            const formattedHours = ('0' + hours).slice(-2)
            const formattedMinutes = ('0' + minutes).slice(-2)
            const hhmm = `${formattedHours}:${formattedMinutes}`
            const slot = timeSlot.timeWindows[dayOfWeek].find(
              (element: any) => element.from === hhmm
            )
            if (slot) {
              const slotObj = {
                date: `${date
                  .getDate()
                  .toString()
                  .padStart(2, '0')}.${month}.${year}`,
                day: dayOfWeek,
                slot,
                slotId: timeSlot.id,
                display: `${date.getDate().toString().padStart(2, '0')}.${month}.${year} ${slot.from} - ${slot.to}`
              }
              this.agentAppointment = slotObj.display
              this.initialAppointment = slotObj.display
              this.timeSlotList.push(slotObj)
            }
          }
        }
        
        // Handhabung des Assessment-Termins
        if (this.agent.assessmentAppointment) {
          const date = new Date(this.agent.assessmentAppointment)
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const year = date.getFullYear().toString()

          const dayOfWeekIndex = date.getDay()
          const days = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ]
          const dayOfWeek = days[dayOfWeekIndex]
          const timeSlot = res?.find((timeSlot: any) => {
            if (
              moment(this.agent.assessmentAppointment).isSame(moment(timeSlot.toDate), 'day') ||
              moment(this.agent.assessmentAppointment).isSame(moment(timeSlot.fromDate), 'day')
            ) {
              return true
            } else if (
              moment(timeSlot.toDate).isAfter(moment(this.agent.assessmentAppointment)) &&
              moment(this.agent.assessmentAppointment).isAfter(moment(timeSlot.fromDate))
            ) {
              return true
            } else {
              return false
            }
          })
          if (!!timeSlot) {
            const hours = date.getHours()
            const minutes = date.getMinutes()
            const formattedHours = ('0' + hours).slice(-2)
            const formattedMinutes = ('0' + minutes).slice(-2)
            const hhmm = `${formattedHours}:${formattedMinutes}`
            const slot = timeSlot.timeWindows[dayOfWeek].find(
              (element: any) => element.from === hhmm
            )
            if (slot) {
              const slotObj = {
                date: `${date
                  .getDate()
                  .toString()
                  .padStart(2, '0')}.${month}.${year}`,
                day: dayOfWeek,
                slot,
                slotId: timeSlot.id,
                display: `${date.getDate().toString().padStart(2, '0')}.${month}.${year} ${slot.from} - ${slot.to}`
              }
              this.agentAssessment = slotObj.display
              this.initialAssessment = slotObj.display
              
              // Prüfen, ob dieser Termin bereits in der Liste ist (könnte durch interviewAppointment schon hinzugefügt worden sein)
              const existingSlot = this.timeSlotList.find((item: any) => item.display === slotObj.display)
              if (!existingSlot) {
                this.timeSlotList.push(slotObj)
              }
            }
          }
        }
      })
  }

  formateTimeSlot(data: any) {
    const formatedData: any[] = [];

    const order: string[] = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    data.forEach((element: any) => {
      const date = new Date(element.fromDate);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();

      order.forEach((day, index) => {
        const dayOfWeek = order.indexOf(day);
        const dayDate = new Date(date);
        dayDate.setDate(dayDate.getDate() + dayOfWeek);
        dayDate.setHours(0, 0, 0, 0);

        if (dayDate > today) {
          element.timeWindows[day].forEach((slot: any) => {
            if (slot.status === 'vacant') {
              formatedData.push({
                date: `${dayDate
                  .getDate()
                  .toString()
                  .padStart(2, '0')}.${month}.${year}`,
                day: day,
                slot,
                slotId: element.id,
                display: `${dayDate.getDate().toString().padStart(2, '0')}.${month}.${year} ${slot.from} - ${slot.to}`
              });
            }
          });
        }
      });
    });
    return formatedData;
  }

  /**
   * Parst einen ISO-Datumsstring und erstellt ein Date-Objekt mit expliziten Komponenten,
   * um Zeitzonen-Probleme zu vermeiden
   * @param isoDateString ISO-Datumsstring im Format YYYY-MM-DDThh:mm
   * @returns Ein Objekt mit dem Date-Objekt und dem formatierten lokalen Datumsstring
   */
  private parseISODateString(isoDateString: string): { date: Date, localFormattedDate: string } {
    const [datePart, timePart] = isoDateString.split('T');
    const [yearStr, monthStr, dayStr] = datePart.split('-');
    const [hourStr, minuteStr] = timePart ? timePart.split(':') : ['00', '00'];
    
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    
    // Erstelle ein neues Date-Objekt mit den extrahierten Komponenten
    // Beachte: Monate sind 0-basiert in JavaScript
    const date = new Date(year, month - 1, day, hour, minute);
    
    // Formatiere das Datum für die lokale Anzeige
    const localFormattedDate = `${('0' + day).slice(-2)}.${('0' + month).slice(-2)}.${year} ${('0' + hour).slice(-2)}:${('0' + minute).slice(-2)}`;
    
    return { date, localFormattedDate };
  }
  
  /**
   * Formatiert ein Date-Objekt in einen ISO-String im Format YYYY-MM-DDThh:mm
   * @param date Das zu formatierende Date-Objekt
   * @returns Formatierter ISO-String
   */
  private formatDateToISOString(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();

    return `${year}-${('0' + month).slice(-2)}-${('0' + day).slice(-2)}T${('0' + hour).slice(-2)}:${('0' + minute).slice(-2)}`;
  }

  public onAppointmentChange() {
    if (!this.appointmentDateTime) return;
    
    this.isSpinnerActive = true;
    
    // Formatiere das Datum mit der Hilfsmethode
    const interviewAppointmentFormatted = this.formatDateToISOString(this.appointmentDateTime);

    // Speichere den vom Benutzer ausgewählten Termin lokal und im localStorage
    const localFormattedDate = `${('0' + this.appointmentDateTime.getDate()).slice(-2)}.${('0' + (this.appointmentDateTime.getMonth() + 1)).slice(-2)}.${this.appointmentDateTime.getFullYear()} ${('0' + this.appointmentDateTime.getHours()).slice(-2)}:${('0' + this.appointmentDateTime.getMinutes()).slice(-2)}`;
    this.userSelectedInterviewTime = localFormattedDate;
    
    // Speichere auch im localStorage für Persistenz nach Refresh
    if (this.agent && this.agent.id) {
      localStorage.setItem(`interview_time_${this.agent.id}`, localFormattedDate);
    }

    console.log('Sende Daten für Appointment:', {
      formattedDate: interviewAppointmentFormatted,
    })
    
    // Finde den nächstgelegenen verfügbaren Slot im Zeitfenster
    const nearestTimeSlot = this.findNearestTimeSlot(this.appointmentDateTime);
    
    this.agentsService
      .scheduleAgentAppointment(this.agent.id, {
        slotId: nearestTimeSlot?.slotId || 1, // Fallback auf 1 falls kein passender Slot gefunden
        formattedDate: interviewAppointmentFormatted,
      })
      .subscribe((res) => {
        console.log('Appointment change res: ', res);
        
        if (res && res.interviewAppointment) {
          try {
            // Setze den Wert aus der Serverantwort
            this.agent.interviewAppointment = res.interviewAppointment;
            // Behalte die vom Benutzer ausgewählte lokale Zeit bei
            this.isDirty = true;
            
            // Benachrichtige andere Komponenten über die Änderung
            this.onselectInterviewDate.emit(this.agent);
            this.sharedService.emitUpdateScheduledCount(true);
            
            if (this.componentInitialized) {
              this.snackBar.open('Interviewtermin zugewiesen', '', {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
              });
            }
          } catch (error) {
            console.error('Fehler beim Verarbeiten des Datums:', error);
          }
        } else {
          console.error('Keine gültige Antwort vom Server erhalten');
        }
        
        this.isSpinnerActive = false;
      });
  }

  public onAssessmentChange() {
    if (!this.assessmentDateTime) return;
    
    this.isSpinnerActive = true;
    
    // Formatiere das Datum mit der Hilfsmethode
    const assessmentAppointmentFormatted = this.formatDateToISOString(this.assessmentDateTime);

    // Speichere den vom Benutzer ausgewählten Termin lokal und im localStorage
    const localFormattedDate = `${('0' + this.assessmentDateTime.getDate()).slice(-2)}.${('0' + (this.assessmentDateTime.getMonth() + 1)).slice(-2)}.${this.assessmentDateTime.getFullYear()} ${('0' + this.assessmentDateTime.getHours()).slice(-2)}:${('0' + this.assessmentDateTime.getMinutes()).slice(-2)}`;
    this.userSelectedAssessmentTime = localFormattedDate;
    
    // Speichere auch im localStorage für Persistenz nach Refresh
    if (this.agent && this.agent.id) {
      localStorage.setItem(`assessment_time_${this.agent.id}`, localFormattedDate);
    }
    
    console.log('Sende Daten für Assessment:', {
      formattedDate: assessmentAppointmentFormatted,
    });
    
    // Finde den nächstgelegenen verfügbaren Slot im Zeitfenster
    const nearestTimeSlot = this.findNearestTimeSlot(this.assessmentDateTime);
    
    this.agentsService
      .scheduleAgentAssessment(this.agent.id, {
        slotId: nearestTimeSlot?.slotId || 1, // Fallback auf 1 falls kein passender Slot gefunden
        formattedDate: assessmentAppointmentFormatted,
      })
      .subscribe((res) => {
        console.log('Assessment change res: ', res);
        
        // Verwende den assessmentAppointment aus der Serverantwort
        if (res && res.assessmentAppointment) {
          try {
            // Setze den Wert aus der Serverantwort für den Backend-Wert
            this.agent.assessmentAppointment = res.assessmentAppointment
            // Wir aktualisieren nicht den DateTimePicker, der bleibt mit dem vom Benutzer gewählten Wert
            this.isDirty = true
            
            // Emittiere Event, um das Kanban-Board zu aktualisieren
            this.assessmentDateChanged.emit({
              agentId: this.agent.id,
              assessmentAppointment: res.assessmentAppointment
            })
            
            if (this.componentInitialized) {
              this.snackBar.open('Assessment-Termin zugewiesen', '', {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
              });
            }
          } catch (error) {
            console.error('Fehler beim Verarbeiten des Datums:', error);
          }
        } else {
          console.error('Keine gültige Antwort vom Server erhalten');
        }
        
        this.isSpinnerActive = false;
      });
  }

  findNearestTimeSlot(date: Date): any {
    const timeSlots = this.timeSlotList.filter((slot: any) => {
      // Datumsformat ist DD.MM.YYYY - wir müssen es umdrehen für die Konvertierung
      if (!slot.date || !slot.slot || !slot.slot.from) return false;
      
      const [day, month, year] = slot.date.split('.');
      const [hour, minute] = slot.slot.from.split(':');
      
      if (!day || !month || !year || !hour || !minute) return false;
      
      const slotDateTime = new Date(+year, +month - 1, +day, +hour, +minute);
      return Math.abs(date.getTime() - slotDateTime.getTime()) < 3600000; // 1 Stunde Zeitfenster
    });
    
    if (timeSlots.length === 0) return null;
    
    return timeSlots.sort((a: any, b: any) => {
      const [aDay, aMonth, aYear] = a.date.split('.');
      const [aHour, aMinute] = a.slot.from.split(':');
      const aDateTime = new Date(+aYear, +aMonth - 1, +aDay, +aHour, +aMinute);
      
      const [bDay, bMonth, bYear] = b.date.split('.');
      const [bHour, bMinute] = b.slot.from.split(':');
      const bDateTime = new Date(+bYear, +bMonth - 1, +bDay, +bHour, +bMinute);
      
      return Math.abs(date.getTime() - aDateTime.getTime()) - Math.abs(date.getTime() - bDateTime.getTime());
    })[0];
  }

  onRemoveInterviewAppointment() {
    console.log('Interview-Termin wird entfernt');
    
    // Setze lokale Werte zurück
    this.agent.interviewAppointment = null;
    this.appointmentDateTime = null;
    this.agentAppointment = null;
    
    // Wichtig: Setze auch die gespeicherten Interaktionsdaten zurück
    this.lastInteractionType['interview'] = null;
    
    // Entferne auch aus localStorage
    if (this.agent && this.agent.id) {
      localStorage.removeItem(`interview_time_${this.agent.id}`)
    }
    
    this.changeDetectorRef.detectChanges();
    
    // Entfernen im Backend
    this.agentsService
      .removeAgentAppointment(this.agent.id, {})
      .subscribe((res) => {
        console.log('Interview-Termin entfernt, Update emittiert');
        this.sharedService.emitUpdateScheduledCount(true);
        
        if (this.componentInitialized) {
          this.snackBar.open('Interviewtermin entfernt', '', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        }
      });
  }
  
  // ViewChild-Referenzen für die DateTimePicker-Elemente
  @ViewChild('appointmentDateTimePicker', { read: ElementRef }) appointmentDateTimePickerEl!: ElementRef;
  @ViewChild('assessmentDateTimePicker', { read: ElementRef }) assessmentDateTimePickerEl!: ElementRef;

  // Speichert, welcher Button (Datum oder Zeit) zuletzt geklickt wurde
  private lastClickedButton: { [key: string]: 'date' | 'time' | null } = {
    'interview': null,
    'assessment': null
  };

  // Speichert die letzte Benutzerinteraktion mit dem DateTimePicker
  private lastInteractionType: { [key: string]: 'date' | 'time' | null } = {
    'interview': null,
    'assessment': null
  };

  // Behandelt Klicks auf den DateTimePicker
  public handleDateTimePickerClick(event: MouseEvent, type: 'interview' | 'assessment'): void {
    console.log(`DateTimePicker für ${type} wurde angeklickt`, event);
    const target = event.target as HTMLElement;
    
    // Verbesserte Erkennung der Icons mit mehreren Selektoren
    const isDateIcon = 
      target.classList.contains('e-date-icon') || 
      target.closest('.e-date-icon') || 
      target.classList.contains('e-input-group-icon') && target.classList.contains('e-date-icon-container') ||
      target.querySelector('.e-date-icon');
      
    const isTimeIcon = 
      target.classList.contains('e-time-icon') || 
      target.closest('.e-time-icon') || 
      target.classList.contains('e-input-group-icon') && target.classList.contains('e-time-icon-container') ||
      target.querySelector('.e-time-icon');
      
    const isClearIcon = 
      target.classList.contains('e-clear-icon') || 
      target.closest('.e-clear-icon');
    
    if (isDateIcon) {
      console.log(`${type} Kalender-Icon wurde angeklickt`);
      this.lastClickedButton[type] = 'date';
    } else if (isTimeIcon) {
      console.log(`${type} Uhrzeit-Icon wurde angeklickt`);
      this.lastClickedButton[type] = 'time';
    } else if (isClearIcon) {
      console.log(`${type} Reset-Button wurde geklickt`);
      // Bei Reset setzen wir keinen lastClickedButton
    } else {
      // Wenn kein spezifisches Icon erkannt wurde, versuchen wir es mit dem DOM-Baum
      const datePickerEl = type === 'interview' ? this.appointmentDateTimePickerEl : this.assessmentDateTimePickerEl;
      if (datePickerEl && datePickerEl.nativeElement) {
        const dateIcon = datePickerEl.nativeElement.querySelector('.e-date-icon');
        const timeIcon = datePickerEl.nativeElement.querySelector('.e-time-icon');
        
        // Prüfen, ob der Klick in der Nähe eines der Icons war
        if (dateIcon && this.isClickNearElement(event, dateIcon)) {
          console.log(`${type} Klick nahe Kalender-Icon erkannt`);
          this.lastClickedButton[type] = 'date';
        } else if (timeIcon && this.isClickNearElement(event, timeIcon)) {
          console.log(`${type} Klick nahe Uhrzeit-Icon erkannt`);
          this.lastClickedButton[type] = 'time';
        }
      }
    }
  }
  
  // Hilfsmethode, um zu prüfen, ob ein Klick in der Nähe eines Elements war
  private isClickNearElement(event: MouseEvent, element: Element, threshold: number = 10): boolean {
    const rect = element.getBoundingClientRect();
    const x = event.clientX;
    const y = event.clientY;
    
    return (
      x >= rect.left - threshold &&
      x <= rect.right + threshold &&
      y >= rect.top - threshold &&
      y <= rect.bottom + threshold
    );
  }

  // Wird aufgerufen, wenn sich der Wert im DateTimePicker ändert
  onAppointmentDateTimeChange(event: any, type: 'interview' | 'assessment'): void {
    console.log(`${type} DateTimePicker change:`, event);
    
    if (!event || !event.value) {
      return;
    }

    const currentDate = new Date(event.value);
    
    // Bestimme, ob der Benutzer das Datum oder die Zeit geändert hat
    // basierend auf dem zuletzt geklickten Button
    const isDateChange = this.lastClickedButton[type] === 'date';
    const isTimeChange = this.lastClickedButton[type] === 'time';
    
    console.log('isDateChange', isDateChange);
    console.log('isTimeChange', isTimeChange);
    console.log('Letzter geklickter Button:', this.lastClickedButton[type]);
  
    // Aktualisiere den Interaktionstyp basierend auf der Änderung
    if (isDateChange) {
      this.lastInteractionType[type] = 'date';
      // Bei Datumswechsel: bestehende Uhrzeit beibehalten statt auf 00:00 zu setzen
      const existingDate = type === 'interview' ? this.appointmentDateTime : this.assessmentDateTime;
      if (existingDate) {
        currentDate.setHours(existingDate.getHours(), existingDate.getMinutes(), 0, 0);
      }
    } else if (isTimeChange) {
      this.lastInteractionType[type] = 'time';
    }
    
    // Aktualisiere das entsprechende Datum
    if (type === 'interview') {
      this.appointmentDateTime = currentDate;
      this.onAppointmentChange();
    } else {
      this.assessmentDateTime = currentDate;
      this.onAssessmentChange();
    }
    
    // Setze den zuletzt geklickten Button zurück
    this.lastClickedButton[type] = null;
    
    // Aktualisiere die Ansicht
    this.changeDetectorRef.detectChanges();
  }

  onRemoveAssessmentAppointment() {
    console.log('Assessment-Termin wird entfernt')
    
    // Setze lokale Werte zurück
    this.assessmentDateTime = null
    this.userSelectedAssessmentTime = null
    
    // Wichtig: Setze auch die gespeicherten Interaktionsdaten zurück
    this.lastInteractionType['assessment'] = null;
    
    // Entferne auch aus localStorage
    if (this.agent && this.agent.id) {
      localStorage.removeItem(`assessment_time_${this.agent.id}`)
    }
    
    // Entfernen im Backend mit der neuen Methode
    this.agentsService
      .removeAgentAssessment(this.agent.id, {})
      .subscribe(
        (res) => {
          console.log('Assessment-Termin erfolgreich entfernt:', res)
          
          // Setze den Agent-Wert nach erfolgreicher Backend-Antwort
          this.agent.assessmentAppointment = null
          this.changeDetectorRef.detectChanges()
          
          // Benachrichtige das Kanban-Board mit Verzögerung
          setTimeout(() => {
            this.assessmentDateChanged.emit({
              agentId: this.agent.id,
              assessmentAppointment: null
            })
          }, 100)
          
          if (this.componentInitialized) {
            this.snackBar.open('Assessment-Termin entfernt', '', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top'
            })
          }
        },
        (error) => {
          console.error('Fehler beim Entfernen des Assessment-Termins:', error)
          this.snackBar.open('Fehler beim Entfernen des Assessment-Termins', '', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top'
          })
        }
      )
  }
  
  // Die alte Methode behalten wir für Kompatibilität
  onRemoveAppointment() {
    this.onRemoveInterviewAppointment();
  }


  navigateToProject(projectId: number): void {
    this.dialogService.showAgentView = false;
    this.timerService.expirationTimeSubject.next('00:00:00');
    this.remainingTime = '00:00:00';
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.closeView.emit(this.agent);
    this.agent = null;
    this.messages = [];
    this.whatsAppMessages = [];
    this.sharedService.agentVoicesSubject.next([]);
    this.router.navigate([`/singleProjectView`, projectId]);
    this.changeDetectorRef.detectChanges();
  }

  changeAgentStatus(status: string) {
    // Speichere den vorherigen Status und eine Kopie des Agenten, bevor er aktualisiert wird
    const previousStatus = this.agent.status
    const agentCopy = {...this.agent}
    
    this.agentsService
      .updateAgentStatus(this.agent.id, { AgentStatus: status })
      .subscribe((res: any) => {
        // Bereite vollständige Agentendaten für das Event vor
        const updatedAgent = {
          ...res,
          previousStatus: previousStatus, // Füge vorherigen Status hinzu
          voiceFiles: agentCopy.voiceFiles || [],
          videoFiles: agentCopy.videoFiles || [],
          // Stelle sicher, dass alle wichtigen Daten enthalten sind
          name: `${res.firstname} ${res.lastname}`,
          id: res.id
        }
        
        // Schließe die Ansicht
        this.dialogService.showAgentView = false
        this.timerService.expirationTimeSubject.next('00:00:00')
        this.remainingTime = '00:00:00'
        if (this.timerSubscription) {
          this.timerSubscription.unsubscribe()
        }
        
        // Emittiere das Event VOR dem Zurücksetzen der lokalen Variablen
        this.onstatusChange.emit(updatedAgent)
        this.closeView.emit(updatedAgent)
        
        // Setze lokale Variablen zurück
        this.agent = null
        this.messages = []
        this.whatsAppMessages = []
        this.sharedService.agentVoicesSubject.next([])
      });
  }

  chooseProfilePhoto(event: any): void {
    this.profilePhoto = event.target.files[0];
    // const reader = new FileReader();
    // reader.onload = () => {
    //   this.profileImageSrc = reader.result as string;
    // };
    // reader.readAsDataURL(event.target.files[0]);
    this.uploadProfilePhoto(this.profilePhoto, this.profilePhoto.type, this.agent.id);
  }

  uploadProfilePhoto(profilePhoto: any, type: string, agentId: number) {
    this.isSpinnerActive = true;
    let blob: any;
    const reader: any = new FileReader();
    reader.readAsArrayBuffer(profilePhoto);
    reader.onload = () => {
      blob = new Blob([reader.result], { type: profilePhoto.type });
      const formData: any = new FormData();
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const fileName = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;

      if (blob instanceof Blob) {
        formData.append('file', blob, fileName);
        formData.append('type', type);
      }
      this.agentsService.setAgentProfilePhoto(agentId, formData).subscribe({
        next: (res: any) => {
          this.isSpinnerActive = false;
          // this.profileImageSrc = res.photoBlob
          this.agent.agentProfilePhoto = res.photoBlob;
          this.profileImageSrc = this.agentsService.convertImagetoUrl(
            res.photoBlob
          );
          this.profilePhoto = null;
        },
        error: (error) => {
          this.isSpinnerActive = false;
          this.profilePhoto = null;
        },
      });
    };
  }

  public onFiltering: EmitType<FilteringEventArgs> = (e: FilteringEventArgs) => {
    let query = new Query();

    if (e.text && e.text.length > 0) {
      // Use "contains" to allow searching anywhere within the country code
      query = query.where('', 'contains', e.text, true); // Case-insensitive
    }

    // Update the data source with the filtered results
    e.updateData(this.countryCode, query);
  };

  detectDevice() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    this.userAgent = navigator.userAgent;
    if (regex.test(navigator.userAgent)) {
      const regexx = /iPhone|iPad|iPod/i;
      if (regexx.test(navigator.userAgent)) {
        this.deviceType = 'iphone';
      } else {
        this.deviceType = 'android';
      }
    } else {
      this.deviceType = 'desktop';
      this.detectWebcam();
    }
  }

  async startCamera() {
    this.isWebcamOn = true;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      this.videoStream = stream;
      this.videoElement.nativeElement.srcObject = stream;
    } catch (error) {
      this.isWebcamOn = false;
      console.error('Error accessing camera:', error);
    }
  }

  takeSnapshot() {
    const video = this.videoElement.nativeElement;
    const canvas = this.canvasElement.nativeElement;
    const context = canvas.getContext('2d');

    if (context) {
      this.isSpinnerActive = true;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        if (blob) {
          if (this.videoStream) {
            this.videoStream.getTracks().forEach(track => track.stop());
          }
          this.isWebcamOn = false;
          const formData: any = new FormData();
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const fileName = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;

          if (blob instanceof Blob) {
            formData.append('file', blob, fileName);
            formData.append('type', blob.type);
          }
          this.agentsService.setAgentProfilePhoto(this.agent.id, formData).subscribe({
            next: (res: any) => {
              this.profileImageSrc = this.agentsService.convertImagetoUrl(
                res.photoBlob
              );
              this.profilePhoto = null;
              this.isSpinnerActive = false;
            },
            error: (error) => {
              this.isSpinnerActive = false;
              this.profilePhoto = null;
            },
          });
        }
      }, 'image/png');
    }
  }

  detectWebcam() {
    let md = navigator.mediaDevices;
    if (!md || !md.enumerateDevices) {
      this.hasWebcam = false;
      return
    };
    md.enumerateDevices().then(devices => {
      this.hasWebcam = devices.some(device => 'videoinput' === device.kind);
    });
  }

  closeWebcam() {
    if (this.videoStream) {
      this.videoStream.getTracks().forEach(track => track.stop());
    }
    this.isWebcamOn = false;
  }

  AddTimeStamp(msg: any) {
    return `${moment(msg.timestamp).format(
      'DD.MM.YYYY HH:mm'
    )} ${msg.content}`
  }

  onApplicationWithdraw() {
    this.agent.isApplicationWithdraw = true;
  }

  sanitizerHtml(htmlString: string) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }

  adjustImage(image: HTMLImageElement): void {
    if (image.naturalWidth === image.naturalHeight) {
      image.style.width = '100%';
      image.style.height = '100%';
    } else if (image.naturalWidth < image.naturalHeight) {
      image.style.width = '100%';
      image.style.height = 'auto';
    } else {
      image.style.width = 'auto';
      image.style.height = '100%';
    }
  }

  public disabledSwitch: Map<number, boolean> = new Map<number, boolean>();

  public onSwitchToggle(event: any, message: Message): void {
    this.disabledSwitch.set(message.id!, true);
    if (!this.isAgentUser ) {
      this.messageService.updateInternFlag(message).subscribe({
        next: (value) => {
          const index = this.messages.findIndex((msg) => msg.id === message.id);
          this.messages[index] = value;


          this.disabledSwitch.set(message.id!, false);
        },
        error: (err) => {
          console.error('Error:', err);
        }
      });
    }
  }

  handleFileChange(event: Event) {
    this.isSpinnerActive = true;
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput?.files?.[0];

    const fileSize = Number(file?.size || 0) / (1024 * 1024);

    const type = file?.type.startsWith('video') ? 'Video' : 'Audio'
    if (type === 'Audio' && fileSize > 10) {
      this.snackBar.open('Die Dateigröße überschreitet die 10MB Grenze!', '', {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'top',
      });
      this.isSpinnerActive = false;
      return;
    }
    else if (type === 'Video' && fileSize > 20) {
      this.snackBar.open('Die Dateigröße überschreitet die 20MB Grenze!', '', {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'top',
      });
      this.isSpinnerActive = false;
      return;
    }

    this.sendToBackend({ blob: file }, type);
  }

  async sendToBackend(blob: any, type: string) {
    this.isSpinnerActive = true;
    const formData = new FormData();
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const fileName = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}.${type == 'Audio' ? 'wav' : 'mp4'}`;

    if (blob.blob instanceof Blob) {
      const zip = new JSZip();
      zip.file(type + '_' + fileName, blob.blob);
      const zippedBlob = await zip.generateAsync({ type: 'blob' });

      formData.append('file', type === 'Audio' ? blob.blob : zippedBlob, type + '_' + fileName);
      formData.append('type', type);
    }

    await this.recordingService.uploadRecording(this.agent.public_id, formData, type).subscribe((res: any) => {
      if (res) {
        if (type === 'Video') {
          this.agent.videoFiles.push(res);
          this.isSpinnerActive = false;
          this.snackBar.open('Die Videodatei wurde erfolgreich hochgeladen', '', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        } else {
          this.agent.voiceFiles.push(res);
          this.isSpinnerActive = false;
          this.snackBar.open('Die Audiodatei wurde erfolgreich hochgeladen', '', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          })
          this.sharedService.agentVoicesSubject.next(this.agent);
          this.ngOnInit();
        }
      }
      // this.sharedService.agentVoicesSubject.next(this.agent);
      const text = `${this.agent.firstname} ${this.agent.lastname} agent hat ${type == 'Audio' ? 'Audioaufnahme' : 'Videoaufzeichnung'} mit Dateiname ${type + '_' + fileName}`;
    })
  }

  close() {
    if (this.isDirty) {
      this.timerService.expirationTimeSubject.next('00:00:00');
      this.remainingTime = '00:00:00';
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
      this.closeView.emit(this.agent);
      this.agent = null;
      this.messages = [];
      this.whatsAppMessages = [];
      this.sharedService.agentVoicesSubject.next([]);
    } else {
      this.timerService.expirationTimeSubject.next('00:00:00');
      this.remainingTime = '00:00:00';
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
      this.closeView.emit(null);
      this.agent = null;
    this.messages = [];
    this.whatsAppMessages = [];
    this.sharedService.agentVoicesSubject.next([]);
    }
    this.dialogService.showAgentView = false;
  }

  onBirthDateChange(date: Date | null): void {
    if (date) {
      this.agent.birthday = date;
    }
  }
  onAvailableDateChange(date: Date | null): void {
    if (date) {
      this.agent.availableFrom = date;
    }
  }
  validateForm(): boolean {
    return (
      !!this.agent.partnerName &&
      !!this.agent.salutation &&
      !!this.agent?.firstname &&
      !!this.agent.lastname &&
      !!this.agent.birthday &&
      !!this.agent.countryCode &&
      !!this.agent.emailAddress &&
      !!this.agent.city &&
      !!this.agent.country &&
      !!this.agent.availableFrom &&
      !!this.agent.experiences &&
      !!this.agent.b2bCapable &&
      !!this.agent?.germanLevel &&
      !!this.agent.englishLevel &&
      !!this.agent.outboundExperienceLevel
    );
  }

  onClickDelete(agent: any) {
    this.agentForDelete = agent;
    this.deleteDialogConfirmationPopup = !this.deleteDialogConfirmationPopup;
    this.currentSW = {};
  }

  onClickJaDelete() {
    this.isSpinnerActive = true;
    this.agentsService.deleteAgent(this.agentForDelete.id).subscribe((res: any) => {
      if (res && res.agent) {
        this.isSpinnerActive = false;
        this.deleteDialogConfirmationPopup = false;
        this.dialogService.showAgentView = false;
        this.timerService.expirationTimeSubject.next('00:00:00');
        this.remainingTime = '00:00:00';
        if (this.timerSubscription) {
          this.timerSubscription.unsubscribe();
        }
        this.closeView.emit({ ...this.agentForDelete, isDeleted: true });
        this.agent = null;
        this.messages = [];
        this.whatsAppMessages = [];
        this.sharedService.agentVoicesSubject.next([]);
        this.agentForDelete = {};
        this.currentSW = {};
      }
    });
  }


  onClickNeinDelete() {
    setTimeout(() => {
      this.agentForDelete.enabled = true;
      this.currentSW.checked = true;
      this.changeDetectorRef.detectChanges();

      this.deleteDialogConfirmationPopup = !this.deleteDialogConfirmationPopup;
      this.agentForDelete = {};
      this.currentSW = {};
    }, 500);
  }

  isMessageEmpty(): boolean {
    if (!this.messageToSent) return true;
    const textContent = this.messageToSent.replace(/<[^>]*>/g, '').trim();
    return textContent.length === 0;
  }

  onPhoneChange(phone: string) {
    let phn = this.agent.countryCode + ' ' + phone;
    if (!phone.startsWith('0')) {
      phn = this.agent.countryCode + ' ' + '0' + phone;
    }
    
    this.phoneChange$.next(phn);
  }

  onEmailChange(email: string) {
    this.emailChange$.next(email);
  }
}
